<template>
  <!-- 找回密码 -->
  <div class="retrievePassword">
    <div class="top-logo flex">
      <div>
        <img class="logo" :src="logImgUrl" alt="">
        <span class="pass-check">{{ $translate('passCheck') }}</span>
      </div>
      <div>
        {{ $translate('hasAccount') }}，<span class="now-login" @click="goToLogin">{{ $translate('loginAway') }}</span>
      </div>
    </div>
    <div class="retrieve-main">
      <div class="main-banner">
        {{ $translate('accountSecurity') }}
      </div>
      <div class="retrieve-content">
        <span
          class="content-title">{{ $route.name == 'retrievePassword' ? $translate('retrievePassword'):$translate('changePassword') }}</span>
        <template v-if="$route.name == 'retrievePassword'">
          <div v-if="emailSuccess" class="forgetForm ">
            <p class="success-text">
              {{ $translate('weHaveReEmail') + emailCode + $translate('Sended') }}
              <br>
              {{ $translate('retrieveEmail') +','+ $translate('attentionPlease') }} <span
                class="strong-text">{{ $translate('receivingMail') }}</span>
            </p>
            <el-button class="retrieve-btn" style="width: 100%;margin-top: 3em;cursor: default" size="medium"
              type="primary">
              {{ $translate('gotoMailbox') }}
            </el-button>
            <p class="tips-text">
              {{ $translate('overPassRetrieveEmail') }}
              <!-- 请注意查收邮件，并按照邮件中的提示操作，完成安全认证。 -->
              <br>
              {{ $translate('notReceived') }} <span class="strong-text pointer"
                @click="emailSuccess = false">{{ $translate('resend') }}</span>
            </p>
          </div>
          <el-form :model="forgetForm" status-icon :rules="forgetFormRlue" v-else ref="forgetForm" class="forgetForm">
            <el-form-item prop="email">
              <el-input prefix-icon="el-icon-message" size="medium" v-model.trim="forgetForm.email"
                :placeholder="$translate('forgetPasswordToEmail')"></el-input>
            </el-form-item>
            <el-form-item>
              <slideRange ref="slideRange" />
            </el-form-item>
            <el-form-item>
              <el-button class="retrieve-btn" style="width: 100%" size="medium" type="primary" :loading="loading"
                @click="forgetSubmit">
                {{ $translate('nextStep') }}
              </el-button>
            </el-form-item>
          </el-form>
        </template>
        <template v-else-if="$route.name == 'changePassword' || $route.name == 'EntranceFromEmail'">
          <changePassword />
        </template>
        <template v-else>
          <forgetPassword />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import slideRange from "./component/sliderRange";
import forgetPassword from "./component/forgetPassword";
import changePassword from "./component/changePassword";
import { baseUrl } from "../../config/env.js";

export default {
  components: { slideRange, forgetPassword, changePassword },
  data() {
    let validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$translate("forgetPasswordToEmail")));
      } else {
        callback();
      }
    };
    return {
      emailSuccess: false,
      emailCode: "",
      logImgUrl: baseUrl + "/resourceFile/logo.png?t=" + Math.random(),
      forgetFormRlue: {
        email: [{ validator: validateEmail, trigger: "submit" }],
      },
      loading: false,
      forgetForm: {
        email: "",
      },
    };
  },
  mounted() {},
  methods: {
    goToLogin() {
      let type = this.$route.query.type || this.$route.query.loginmode;

      const url = this.$getOrigin();
      const { appName, adminName } = this.$store.state;

      if (type) {
        if (type == "admin") {
          location.href = `${url}/${adminName}/#/login`;
        } else if (type == "mobile") {
          location.href = url + "/mobile/#/login";
        } else {
          location.href = `${url}/${appName}/#/login`;
        }
      } else {
        location.href = `${url}/${appName}/#/login`;
      }
    },
    forgetSubmit() {
      this.$refs.forgetForm.validate((valid) => {
        if (valid) {
          if (!this.$refs.slideRange.verification) {
            this.$message({
              message: this.$translate("dragTheSlider"),
              showClose: true,
              type: "warning",
            });
            return;
          }
          this.loading = true;
          let loginMode =
            (this.$route.query && this.$route.query.type) || "client";
          this.$api.Access.ForgotPassword({
            email: this.forgetForm.email,
            loginMode,
          }).then((res) => {
            if (res) {
              if (res.data && res.data.isSuccess) {
                this.$message({
                  message: res.data.message,
                  showClose: true,
                  type: "success",
                });
                this.emailSuccess = true;
                this.emailCode = this.forgetForm.email;
                this.forgetForm.email = "";
                this.$refs.forgetForm.resetFields();
              } else {
                this.$message({
                  showClose: true,
                  message:
                    res.data && res.data.message
                      ? res.data.message
                      : this.$translate("emailDeliveryFailed"),
                  type: "warning",
                });
              }
            }
            this.loading = false;
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.retrievePassword {
  padding: 5% 15%;
  font-size: 12px;
  height: 100%;
  background-color: #f4f5f7;
  .top-logo {
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    .logo {
      vertical-align: middle;
      max-width: 30vw;
      max-height: 40px;
      margin-right: 1em;
    }
    .pass-check {
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0rem;
      color: #000000;
      vertical-align: text-top;
    }
    .now-login {
      font-size: 0.1rem;
      font-weight: normal;
      letter-spacing: 0rem;
      color: #5e74fc;
      cursor: pointer;
    }
  }
  .retrieve-main {
    margin-top: 10px;
    background-color: #fff;
    text-align: center;
    height: 66vh;
    .main-banner {
      height: 60px;
      line-height: 60px;
      text-align: center;
      background-color: #6078f8;
      font-size: 22px;
      color: #ffffff;
    }
    .retrieve-content {
      padding-top: 3em;
      .content-title {
        font-size: 18px;
      }
      .forgetForm {
        width: 340px;
        margin: 10px auto;
        margin-top: 3em;
        .success-text {
          line-height: 26px;
        }
        .strong-text {
          font-size: 14px;
          font-weight: normal;
          letter-spacing: 0px;
          color: #6078f8;
        }
        .tips-text {
          margin-top: 2em;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 20px;
          letter-spacing: 0px;
          color: #999999;
        }
      }
    }
  }
}
@media only screen and (min-width: 321px) and (max-width: 1024px) {
  .retrievePassword {
    padding: 5% 0;
  }
}
</style>
